<template>
  <div id="contenedor-main-reporte-semanal">
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <!-- ToolBar -->
    <tool-bar
      v-if="!$apollo.loading"
      ref="toolBarAcciones"
      class="mb-4 d-print-none"
      :contratos="getContratos"
      :filtros="filtros"
      v-on:exportarPdf="generarPdf">
    </tool-bar>
    <listado
      v-if="!$apollo.loading"
      class="d-print-none"
      :tipo="filtros.tipoLista"
      :listado="getReportes">
    </listado>
    <print>
      <template
        v-slot:header>
        <v-row no-gutters>
          <v-col
            cols="auto">
            <img
              src="@/assets/cidue-logo.png"
              width="200"
              height="65" />
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="auto">
            <h3>INFORME EJECUTIVO</h3>
            <h4>
              AL
              {{ new Date().toLocaleDateString() }}
            </h4>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </template>
      <template
        v-slot:contenido>
        <listado
          :tipo="1"
          :listado="getReportes"
          imprimir>
        </listado>
      </template>
    </print>
  </div>
</template>

<script>
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import CONTRATO_REPORTES_FISICOS_TODOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratosReportesFisicosTodos.gql';
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import Print from '@/components/Print.vue';

const HACE_SIETE_DIAS = new Date();
HACE_SIETE_DIAS.setDate(HACE_SIETE_DIAS.getDate() - 7);

export default {
  name: 'MainReportesReporteSemanal',
  components: {
    ToolBar,
    Listado,
    Print,
  },
  mixins: [mixGenerarPdf],
  data() {
    return {
      listadoMostrarDetalles: [],
      filtros: {
        tipoLista: 0,
        fechaInicio: this.$fecha().parseEng(HACE_SIETE_DIAS),
        fechaTermino: this.$fecha().parseEng(new Date()),
        buscarTexto: '',
        idContratoEstatus: null,
        estatus: null,
        tipo: 'Todos',
        contratistas: [],
        supervisores: [],
      },
    };
  },
  apollo: {
    contratosReportesFisicosTodos: {
      query: CONTRATO_REPORTES_FISICOS_TODOS,
      variables() {
        return {
          fechaInicio: this.filtros.fechaInicio,
          fechaTermino: this.filtros.fechaTermino,
        };
      },
    },
    contratos: {
      query: CONTRATOS,
    },
  },
  methods: {
    async generarPdf() {
      this.$refs.toolBarAcciones.seEstaEnviando = true;

      await this.mixGenerarPdf({
        configuracion: {
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate: 'reporteSemanal',
        },
        data: {
          fecha: {
            inicio: this.getFechaInicioFormateada,
            termino: this.getFechaTerminoFormateada,
          },
          listado: this.getReportes,
        },
      }, this.getNombreDelArchivo);

      this.$refs.toolBarAcciones.seEstaEnviando = false;
    },
  },
  computed: {
    getNombreDelArchivo() {
      const { fechaTermino } = this.filtros;
      const hoy = new Date().toLocaleDateString();
      const fechaTerminoFormato = new Date(`${fechaTermino} 00:00:0`).toLocaleDateString();

      if (fechaTermino) {
        return `REPORTE SEMANAL - ${fechaTerminoFormato}`;
      }
      return `REPORTE SEMANAL - ${hoy}`;
    },
    getFechaTerminoFormateada() {
      const { fechaTermino } = this.filtros;
      const hoy = new Date().toLocaleDateString();
      const fechaTerminoFormato = new Date(`${fechaTermino} 00:00:0`).toLocaleDateString();

      if (fechaTermino) {
        return fechaTerminoFormato;
      }
      return hoy;
    },
    getFechaInicioFormateada() {
      const { fechaInicio } = this.filtros;
      const hoy = new Date().toLocaleDateString();
      const fechaInicioFormato = new Date(`${fechaInicio} 00:00:0`).toLocaleDateString();

      if (fechaInicio) {
        return fechaInicioFormato;
      }
      return hoy;
    },
    getReportes() {
      if (!this.contratosReportesFisicosTodos) return [];
      return this.contratosReportesFisicosTodos
        .map((reporte) => ({
          ...reporte, mostrarDetalles: false,
        }))
        .map((reporte) => {
          let descripcionAtraso = {
            color: 'red darken-3',
            texto: 'Muy atrasada',
            orden: 0,
            dark: true,
          };
          const porcentajeDeAtraso = this
            .$numberRound((reporte.avanceProgramado - reporte.avanceFisico));

          if (porcentajeDeAtraso <= 5) {
            descripcionAtraso = {
              color: 'green darken-1',
              texto: 'A tiempo',
              orden: 2,
              dark: true,
            };
          }

          if (porcentajeDeAtraso > 5 && porcentajeDeAtraso <= 25) {
            descripcionAtraso = {
              color: 'yellow lighten-2',
              texto: 'Atrasada',
              orden: 1,
              dark: false,
            };
          }

          return {
            ...reporte,
            porcentajeDeAtraso,
            descripcionAtraso,
          };
        })
        .map((reporte) => ({
          ...reporte,
          fechaReporteFormato: new Date(`${reporte.fecha} 00:00:0`)
            .toLocaleDateString(),
        }))
        .map((reporte) => {
          const nuevoReporte = reporte;
          const { importeTotal } = reporte.contrato;
          nuevoReporte.contrato.importeTotalFormato = this.$options.filters.currency(importeTotal);

          return {
            ...nuevoReporte,
          };
        })
        .map((reporte) => {
          const supervisor = reporte.contrato.responsables
            .find(({ principal }) => principal === true);
          return {
            ...reporte,
            supervisor,
          };
        })
        .map((reporte) => {
          const { esObraFinanciada } = reporte.contrato;
          const importeTotalAnticipo = this
            .$ObjSumar(reporte.contrato.anticipos, !esObraFinanciada ? 'importe' : 'importeInicioTrabajos');
          const fechaAnticipo = reporte.contrato.anticipos.length > 0
            ? new Date(`${reporte.contrato?.anticipos[0]?.fecha} 00:00:0`)
              .toLocaleDateString()
            : 'Sin anticipo';
          return {
            ...reporte,
            importeTotalAnticipo,
            importeTotalAnticipoFormato: this.$options.filters.currency(importeTotalAnticipo),
            fechaAnticipo,
          };
        })
        .map((reporte) => {
          let albumFotografico = [];
          reporte.partidas.forEach((partida) => {
            if (partida.imagenes) {
              albumFotografico = [...partida.imagenes];
            }
          });
          return {
            ...reporte,
            albumFotografico,
          };
        })
        // Filtrar por fecha de inicio y termino
        .filter(({ fecha }) => {
          const nuevaFecha = new Date(`${fecha} 00:00:00`);

          const { fechaInicio, fechaTermino } = this.filtros;
          if (!fechaInicio || !fechaTermino) return true;

          return nuevaFecha >= new Date(`${fechaInicio} 00:00:0`)
          && nuevaFecha <= new Date(`${fechaTermino} 00:00:0`);
        })
        // Buscar por texto
        .filter(({ comentarios, contrato }) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');

          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const razonSocial = this.$normalizacionTexto(contrato.contratista.nombreRazonSocial);
          const nuevosComentarios = this.$normalizacionTexto(comentarios);

          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(razonSocial)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
            || expt.test(comentarios)
            || expt.test(nuevosComentarios)
          );
        })
        // Filtrar por estatus del contrato
        .filter(({ contrato }) => {
          const { idContratoEstatus } = contrato;
          if (!this.filtros.idContratoEstatus) return true;

          return idContratoEstatus === this.filtros.idContratoEstatus;
        })
        // Filtrar por tipo de contrato
        .filter(({ contrato }) => {
          const { esObraFinanciada } = contrato;
          if (this.filtros.tipo === 'Todos') return true;

          if (this.filtros.tipo === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Filtro por contratista
        .filter(({ contrato }) => {
          const { idContratista } = contrato;
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ contrato }) => {
          const { responsables } = contrato;
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .sort((a, b) => a.descripcionAtraso.orden - b.descripcionAtraso.orden);
    },
    getInformesPdf() {
      return this.getReportes.map((reporte) => reporte);
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos;
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes {
  border: 1px solid #ccc;
}
</style>
